import React, { useState } from 'react';
import { StarIcon, QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  author: 'Sarah Chen',
  role: 'Director of Trade-In Operations',
  company: 'MobileTech Retail',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mobiletech-logo.png',
  content: "R3UP's platform has transformed our trade-in program. We've seen a 40% increase in trade-in volume and significantly reduced our assessment times. The AI-powered diagnostics are incredibly accurate.",
  rating: 5
}, {
  author: 'Michael Rodriguez',
  role: 'VP of Operations',
  company: 'Global Device Solutions',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gds-logo.png',
  content: 'The wholesale marketplace has opened up new opportunities for our business. The automated grading system and market insights help us make better buying decisions and maximize returns.',
  rating: 5
}, {
  author: 'Emily Thompson',
  role: 'Head of Sustainability',
  company: 'EcoTech Wireless',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ecotech-logo.png',
  content: "Not only has R3UP helped us scale our device trade-in program, but it's also supporting our sustainability goals. The platform's efficiency in processing and reselling devices has significantly reduced e-waste.",
  rating: 5
}, {
  author: 'David Kim',
  role: 'CTO',
  company: 'TechTrade Solutions',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/techrade-logo.png',
  content: 'The integration was seamless and the results were immediate. Our trade-in volume increased by 65% in the first quarter after implementation.',
  rating: 5
}, {
  author: 'Lisa Martinez',
  role: 'Retail Operations Manager',
  company: 'SmartDevice Exchange',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/smartdevice-logo.png',
  content: "R3UP's market insights have been invaluable. We're now able to make data-driven decisions about our trade-in programs and inventory management.",
  rating: 5
}, {
  author: 'James Wilson',
  role: 'CEO',
  company: 'CircuitCycle',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/circuitcycle-logo.png',
  content: "As a circular economy focused business, R3UP's platform aligns perfectly with our mission. The efficiency and accuracy of their AI system is unmatched.",
  rating: 5
}];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(current => current + 3 >= testimonials.length ? 0 : current + 3);
  };
  const previous = () => {
    setCurrentIndex(current => current - 3 < 0 ? testimonials.length - 3 : current - 3);
  };
  return <section className="bg-white dark:bg-black py-20" data-id="element-942">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-943">
        <div className="text-center mb-16" data-id="element-944">
          <div className="inline-flex items-center px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-945">
            Trusted by Industry Leaders
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-946">
            See What Our Partners Say
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-947">
            Join hundreds of businesses that trust R3UP to power their device
            trade-in programs
          </p>
        </div>
        <div className="relative" data-id="element-948">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-949">
            {testimonials.slice(currentIndex, currentIndex + 3).map((testimonial, index) => <div key={index} className="bg-gray-50 dark:bg-gray-900 rounded-xl p-8 border border-gray-200 dark:border-gray-800 relative" data-id="element-950">
                  <QuoteIcon className="absolute top-6 right-8 h-16 w-16 text-gray-100 dark:text-gray-800" data-id="element-951" />
                  <div className="relative" data-id="element-952">
                    <div className="flex space-x-1 mb-4" data-id="element-953">
                      {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-954" />)}
                    </div>
                    <blockquote className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-955">
                      "{testimonial.content}"
                    </blockquote>
                    <div className="flex items-center" data-id="element-956">
                      <div className="flex-1" data-id="element-957">
                        <div className="font-medium text-gray-900 dark:text-white" data-id="element-958">
                          {testimonial.author}
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-959">
                          {testimonial.role}
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-960">
                          {testimonial.company}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
          </div>
          <div className="absolute top-1/2 -left-12 -translate-y-1/2" data-id="element-961">
            <button onClick={previous} className="p-2 rounded-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green transition-colors" data-id="element-962">
              <ChevronLeftIcon className="h-6 w-6" data-id="element-963" />
            </button>
          </div>
          <div className="absolute top-1/2 -right-12 -translate-y-1/2" data-id="element-964">
            <button onClick={next} className="p-2 rounded-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green transition-colors" data-id="element-965">
              <ChevronRightIcon className="h-6 w-6" data-id="element-966" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}